// WhatsApp reminders card: string lookup. The app dictionary (host.T) is the only source. host.T returns the key itself for an unknown key (see T in index.html), so a missing key shows as the key, never as invented text.
export function makeT(host) {
  return function t(key, vars) {
    try { if (host && typeof host.T === 'function') return host.T(key, vars); } catch (_) { /* fall through to the key */ }
    return key;
  };
}
